<template>
  <div class="survey-radio-question">
    <p class="survey-radio-question__title" v-html="formattedTitle" />

    <div class="survey-radio-question__box list-questions__answer">
      <p v-if="groupTitle" class="list-questions__text">{{ groupTitle }}</p>

      <div class="list-questions__btns flex flex-column w-full">
        <div
            v-for="(option, index) in options"
            :key="index"
            class="list-questions__radio-wrap flex"
        >
          <label :for="`${groupName}_${index}`">{{ getOptionText(option) }}</label>
          <input
              :id="`${groupName}_${index}`"
              :name="groupName"
              type="radio"
              :value="getOptionValue(option, index)"
              :checked="modelValue === getOptionValue(option, index)"
              @change="onSelect(option, index)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'SurveyRadioQuestion',
  props: {
    title: {
      type: String,
      required: true,
    },
    highlight: {
      type: String,
      default: '',
    },
    groupTitle: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: Number,
      default: null,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const groupName = `survey_radio_${Math.random().toString(36).slice(2, 9)}`;

    const formattedTitle = computed(() => {
      if (!props.highlight) {
        return props.title;
      }

      return props.title.replace(
          `{highlight}`,
          `<span class="survey-radio-question__highlight">${props.highlight}</span>`,
      );
    });

    const onSelect = (option, index) => {
      emit('update:modelValue', getOptionValue(option, index));
    };

    const getOptionText = (option) => {
      return typeof option === 'object' && option !== null ? option.text : option;
    };

    const getOptionValue = (option, index) => {
      return typeof option === 'object' && option !== null ? option.value : index;
    };

    return {
      groupName,
      formattedTitle,
      onSelect,
      getOptionText,
      getOptionValue,
    };
  },
};
</script>

<style scoped lang="scss">
$survey-answer-bg: #00000005;

.survey-radio-question {
  display: flex;
  flex-direction: column;
  gap: 20px;

  &__title {
    margin: 0;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 120%;

    :deep(.survey-radio-question__highlight) {
      color: var(--main-green);
      font-weight: 600;
    }
  }

  &__box {
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 16px;
    border-radius: 8px;
    background: $survey-answer-bg;
    width: 100%;
    max-width: 100%;
    margin: 0;
  }
}

.list-questions__text {
  margin: 0 0 15px;
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
  color: var(--main-font);
  white-space: break-spaces;
  word-break: break-word;
}

.list-questions__btns {
  row-gap: 12px;
}

.list-questions__radio-wrap {
  position: relative;
  flex: 1;
  flex-direction: row-reverse;
  column-gap: 8px;

  label {
    display: block;
    text-align: left;
    flex: 1 0;
    word-break: keep-all;
    font-size: 14px;
    line-height: 120%;
    font-weight: 400;
    color: var(--main-font);
    padding: 0 20px 0 0;
    white-space: break-spaces;
    cursor: pointer;
  }

  input {
    width: 16px;
    height: 16px;
    display: block;
    background-color: #fff;
    border: 1px solid var(--cream-color);
    border-radius: 50%;
    appearance: none;
    cursor: pointer;
    margin-top: 3px;
    position: relative;
    z-index: 2;
    flex-shrink: 0;
  }

  input:hover,
  input:focus {
    border-color: var(--main-green) !important;
  }

  input:checked {
    background-color: #fff !important;
    border: 1px solid var(--main-green) !important;
  }

  input:checked::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 8px;
    height: 8px;
    transform: translate(-50%, -50%);
    background: var(--main-green);
    border-radius: 50%;
  }
}
</style>
